import gql from 'graphql-tag';
export const ALL_EMPLOYEES_SURVEY_TOKEN = gql`
query allEmployees($nameIcontains: String) {
  allEmployees(nameIcontains: $nameIcontains) {
        edges {
            node {
              id
              user {
                id
                firstName
                lastName
                email
              }
            }
          }
       } 
     }
`;


export const ORGANIZATION_EMPLOYEE_LIST = gql`
query allEmployeesOrganisationEmployeeList($search:String){
  first_name:allOrganizationEmployees(user_FirstName:$search,first:10, user_Status_Verified: true){
    edges{
      node{
        id
        user{
          id
          firstName
          lastName
          email
        }
      }
    }
  }
  last_name:allOrganizationEmployees(user_LastName:$search,first:10, user_Status_Verified: true){
    edges{
      node{
        id
        user{
          id
          firstName
          lastName
          email
        }
      }
    }
  }
  email:allOrganizationEmployees(user_Email:$search,first:10, user_Status_Verified: true){
    edges{
      node{
        id
        user{
          id
          firstName
          lastName
          email
        }
      }
    }
  }
}
`